export default function hasJWT() {
  return localStorage.getItem("b2bAppToken") !== null;
}
